import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/index/index.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/to_do',
    name: 'to_do',
    component: () => import('@/views/to_do/to_do.vue'),
  },
  {
    path: '/to_do-info',
    name: 'to_do-info',
    component: () => import('@/views/to_do-info/to_do-info.vue'),
  },
  {
    path: '/event_intervention',
    name: 'event_intervention',
    component: () => import('@/views/event_intervention/1966793477014491137.vue'),
  },
  {
    path: '/estateFinancialReport',
    name: 'estateFinancialReport',
    component: () => import('@/views/estate_financial_report/1968800420721659905.vue'),
  },
  {
    path: '/funds',
    name: 'funds',
    component: () => import('@/views/funds/funds.vue'),
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/views/notice/notice.vue'),
  },
]
const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
